import React from "react";
import profile_img from '../../utils/profile.jpeg';

import Button from "../../components/scripts/Button";
import '../styles/About.css';

import my_cv from '../../utils/Sourabh_CV.pdf';

class About extends React.Component{
    render(){
        const {details} = this.props;
        return(
            <div className="about-div">
                <div className="profile_div">
                    <img src={profile_img} alt="avatar"></img>
                </div>
                <div className="desc_div">
                    <div className="header-div">
                        <div className="sub-title-div">
                            <p className="tc">
                                About Me
                            </p>
                        </div>
                        <div className="detail_div">
                            <p>
                                {details.description}
                            </p>
                        </div>
                        <div className="resume_div">
                            <Button text={'Resume'} link={my_cv} isResume={'true'}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;